var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"container"},[_c('div',{staticClass:"row h-100"},[_c('div',{staticClass:"content col-12",domProps:{"innerHTML":_vm._s(_vm.$t('pages.agb.content'))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }